export const appPrompt = 'vancery_app_prompt';
export const consent = 'vancerycookieconsent';
export const loggedInAppPrompt = 'vancery_logged_in_prompt';
export const referral = 'referral';